import { Component, ContentChildren, type QueryList } from '@angular/core';

import { NavbarMenuItemComponent } from '../navbar-menu-item/navbar-menu-item.component';

@Component({
  selector: 'myre-nav-menu',
  templateUrl: './navbar-menu.component.html',
  styleUrls: ['./navbar-menu.component.scss'],
})
export class NavbarMenuComponent {
  @ContentChildren(NavbarMenuItemComponent)
  public menuItem: QueryList<NavbarMenuItemComponent>;
}
